module.exports = __webpack_public_path__ + "img/exerciseBg.7807fa56.png";